import {
  REQUESTTIME_FETCHING,
  REQUESTTIME_SUCCESS,
  REQUESTTIME_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case REQUESTTIME_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case REQUESTTIME_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case REQUESTTIME_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
